import Box from "@material-ui/core/Box";
import ButtonBase from "@material-ui/core/ButtonBase";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import { fade, makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: theme.spacing(2),
    marginTop: theme.spacing(1.5),
  },
  card: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "left",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    width: "100%",
  },
  cardSelected: {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${fade(theme.palette.primary.main, 0.2)}`,
  },
  colorBadge: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    marginRight: theme.spacing(1.5),
    border: `2px solid ${theme.palette.background.paper}`,
    boxShadow: theme.shadows[1],
  },
  left: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    flex: 1,
  },
  name: {
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
  },
  helperText: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  checkIcon: {
    color: theme.palette.primary.main,
  },
  emptyLabel: {
    color: theme.palette.warning.main,
    fontWeight: 500,
    textAlign: "center",
  },
}));

const QueueSelect = ({ selectedQueueIds, onChange, companyId, hideLabel = false }) => {
  const classes = useStyles();
  const [queues, setQueues] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue",{
          params:{
            companyId
          }
        });        
        setQueues(data);
      } catch (err) {        
        toastError(err);
      }
    })();
  }, []);
  
  const toggleQueue = (queueId) => {
    if (selectedQueueIds?.includes(queueId)) {
      onChange(selectedQueueIds.filter((id) => id !== queueId));
      return;
    }
    onChange([...(selectedQueueIds || []), queueId]);
  };

  return (
    <div style={{ marginTop: 6 }}>
      <FormControl fullWidth margin="dense" component="fieldset">
        {!hideLabel ? (
          <FormLabel component="legend" style={{ textAlign: "center" }}>
            {i18n.t("queueSelect.inputLabel")}
          </FormLabel>
        ) : null}
        {!selectedQueueIds?.length ? (
          <Typography variant="body2" className={classes.emptyLabel}>
            {i18n.t("queueSelect.withoutQueue")}
          </Typography>
        ) : null}
        <Box className={classes.cards}>
          {queues.map((queue) => {
            const selected = selectedQueueIds?.includes(queue.id);
            return (
              <ButtonBase
                key={queue.id}
                onClick={() => toggleQueue(queue.id)}
                className={clsx(classes.card, selected && classes.cardSelected)}
              >
                <Box className={classes.left}>
                  <span
                    className={classes.colorBadge}
                    style={{ backgroundColor: queue.color || "#999" }}
                  />
                  <Typography variant="subtitle2" className={classes.name}>
                    {queue.name}
                  </Typography>
                </Box>
                {selected ? <CheckCircleIcon fontSize="small" className={classes.checkIcon} /> : null}
              </ButtonBase>
            );
          })}
        </Box>
      </FormControl>
    </div>
  );
};

export default QueueSelect;
